import { withStyles } from '@material-ui/core';
import MenuItem from './MenuItem';
import styles from './styles';


export default withStyles(styles)(MenuItem);
